export default {
  // Generic
  "generic.add": "Toevoegen",
  "generic.cancel": "Annuleren",

  // BlockType
  "components.controls.blocktype.h1": "H1",
  "components.controls.blocktype.h2": "H2",
  "components.controls.blocktype.h3": "H3",
  "components.controls.blocktype.h4": "H4",
  "components.controls.blocktype.h5": "H5",
  "components.controls.blocktype.h6": "H6",
  "components.controls.blocktype.blockquote": "Blockquote",
  "components.controls.blocktype.code": "Code",
  "components.controls.blocktype.blocktype": "Blocktype",
  "components.controls.blocktype.normal": "Normaal",

  // Color Picker
  "components.controls.colorpicker.colorpicker": "Kleurkiezer",
  "components.controls.colorpicker.text": "Tekst",
  "components.controls.colorpicker.background": "Achtergrond",

  // Embedded
  "components.controls.embedded.embedded": "Ingevoegd",
  "components.controls.embedded.embeddedlink": "Ingevoegde link",
  "components.controls.embedded.enterlink": "Voeg link toe",

  // Emoji
  "components.controls.emoji.emoji": "Emoji",

  // FontFamily
  "components.controls.fontfamily.fontfamily": "Lettertype",

  // FontSize
  "components.controls.fontsize.fontsize": "Lettergrootte",

  // History
  "components.controls.history.history": "Geschiedenis",
  "components.controls.history.undo": "Ongedaan maken",
  "components.controls.history.redo": "Opnieuw",

  // Image
  "components.controls.image.image": "Afbeelding",
  "components.controls.image.fileUpload": "Bestand uploaden",
  "components.controls.image.byURL": "URL",
  "components.controls.image.dropFileText":
    "Drop het bestand hier of klik om te uploaden",

  // Inline
  "components.controls.inline.bold": "Dikgedrukt",
  "components.controls.inline.italic": "Schuingedrukt",
  "components.controls.inline.underline": "Onderstrepen",
  "components.controls.inline.strikethrough": "Doorstrepen",
  "components.controls.inline.monospace": "Monospace",
  "components.controls.inline.superscript": "Superscript",
  "components.controls.inline.subscript": "Subscript",

  // Link
  "components.controls.link.linkTitle": "Linktitel",
  "components.controls.link.linkTarget": "Link bestemming",
  "components.controls.link.linkTargetOption": "Open link in een nieuw venster",
  "components.controls.link.link": "Link",
  "components.controls.link.unlink": "Unlink",

  // List
  "components.controls.list.list": "Lijst",
  "components.controls.list.unordered": "Ongeordend",
  "components.controls.list.ordered": "Geordend",
  "components.controls.list.indent": "Inspringen",
  "components.controls.list.outdent": "Inspringen verkleinen",

  // Remove
  "components.controls.remove.remove": "Verwijderen",

  // TextAlign
  "components.controls.textalign.textalign": "Tekst uitlijnen",
  "components.controls.textalign.left": "Links",
  "components.controls.textalign.center": "Gecentreerd",
  "components.controls.textalign.right": "Rechts",
  "components.controls.textalign.justify": "Uitgelijnd"
};
